(() => {
  const money = new Intl.NumberFormat(document.documentElement.lang || 'it-IT', {
    style: 'currency',
    currency: window.Shopify?.currency?.active || 'EUR'
  });

  const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, (character) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
  })[character]);

  document.querySelectorAll('[data-nv-box-builder]').forEach((builder) => {
    const formatButtons = [...builder.querySelectorAll('[data-box-format]')];
    const productCards = [...builder.querySelectorAll('[data-box-product]')];
    const filterButtons = [...builder.querySelectorAll('[data-box-filter]')];
    const searchInput = builder.querySelector('[data-box-search]');
    const searchClear = builder.querySelector('[data-box-search-clear]');
    const noResults = builder.querySelector('[data-box-no-results]');
    const pagination = builder.querySelector('[data-box-pagination]');
    const pageList = builder.querySelector('[data-box-page-list]');
    const pageStatus = builder.querySelector('[data-box-page-status]');
    const pagePrev = builder.querySelector('[data-box-page-prev]');
    const pageNext = builder.querySelector('[data-box-page-next]');
    const composer = builder.querySelector('[data-box-composer]');
    const capacityMessage = builder.querySelector('[data-box-capacity-message]');
    const summaryTitle = builder.querySelector('[data-box-summary-title]');
    const summaryStatus = builder.querySelector('[data-box-summary-status]');
    const summaryEmpty = builder.querySelector('[data-box-summary-empty]');
    const summaryItems = builder.querySelector('[data-box-summary-items]');
    const subtotalElement = builder.querySelector('[data-box-subtotal]');
    const savingRow = builder.querySelector('[data-box-saving-row]');
    const discountLabel = builder.querySelector('[data-box-discount-label]');
    const discountElement = builder.querySelector('[data-box-discount]');
    const packageElement = builder.querySelector('[data-box-package]');
    const totalElement = builder.querySelector('[data-box-total]');
    const message = builder.querySelector('[data-box-message]');
    const messageCount = builder.querySelector('[data-box-message-count]');
    const submit = builder.querySelector('[data-box-submit]');
    const errorElement = builder.querySelector('[data-box-error]');
    const progress = [...builder.querySelectorAll('[data-box-progress]')];
    const discountCodes = {
      5: builder.dataset.discountCode5?.trim() || '',
      8: builder.dataset.discountCode8?.trim() || '',
      10: builder.dataset.discountCode10?.trim() || ''
    };

    const selection = new Map();
    let selectedFormat = null;
    let activeFilter = 'all';
    let activeSearch = '';
    let activePage = 1;
    const pageSize = 6;

    const normalizeSearch = (value = '') => String(value)
      .toLocaleLowerCase('it')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();

    const applyProductFilters = () => {
      const matchingCards = productCards.filter((card) => {
        const categoryMatches = activeFilter === 'all' || card.dataset.productCategory === activeFilter;
        const searchText = normalizeSearch(`${card.dataset.title || ''} ${card.textContent || ''}`);
        const searchMatches = !activeSearch || searchText.includes(activeSearch);
        return categoryMatches && searchMatches;
      });
      const totalPages = Math.max(1, Math.ceil(matchingCards.length / pageSize));
      activePage = Math.min(activePage, totalPages);
      const firstIndex = (activePage - 1) * pageSize;
      const visibleCards = matchingCards.slice(firstIndex, firstIndex + pageSize);

      productCards.forEach((card) => {
        card.hidden = !visibleCards.includes(card);
      });

      if (noResults) noResults.hidden = matchingCards.length !== 0;
      if (searchClear) searchClear.hidden = !activeSearch;
      if (pagination) pagination.hidden = matchingCards.length <= pageSize;

      if (pageStatus) {
        const lastIndex = Math.min(firstIndex + pageSize, matchingCards.length);
        pageStatus.textContent = matchingCards.length
          ? `${firstIndex + 1}–${lastIndex} di ${matchingCards.length} prodotti`
          : 'Nessun prodotto';
      }

      if (pageList) {
        pageList.innerHTML = Array.from({ length: totalPages }, (_, index) => {
          const page = index + 1;
          return `<button type="button" data-box-page="${page}"${page === activePage ? ' class="is-active" aria-current="page"' : ''}>${page}</button>`;
        }).join('');
      }
      if (pagePrev) pagePrev.disabled = activePage <= 1;
      if (pageNext) pageNext.disabled = activePage >= totalPages;
    };

    const setCardVariant = (card, variantButton) => {
      card.dataset.variantId = variantButton.dataset.variantId;
      card.dataset.productSize = variantButton.dataset.variantSize;
      card.dataset.title = variantButton.dataset.selectionTitle;
      card.dataset.price = variantButton.dataset.variantPrice;
      card.dataset.priceLabel = variantButton.dataset.variantPriceLabel;
      card.dataset.image = variantButton.dataset.variantThumb || variantButton.dataset.variantImage || '';
      card.dataset.onSale = variantButton.dataset.variantOnSale;
      card.dataset.unavailable = String(variantButton.dataset.variantAvailable !== 'true');

      card.querySelectorAll('[data-box-variant]').forEach((button) => {
        const selected = button === variantButton;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', String(selected));
      });

      const image = card.querySelector('.nv-box-builder-product__media > img');
      if (image && variantButton.dataset.variantImage) {
        image.src = variantButton.dataset.variantImage;
        image.removeAttribute('srcset');
      }
      const price = card.querySelector('[data-box-product-price]');
      if (price) price.textContent = variantButton.dataset.variantPriceLabel;
      const compare = card.querySelector('[data-box-product-compare]');
      if (compare) {
        compare.textContent = variantButton.dataset.variantCompareLabel || '';
        compare.hidden = !variantButton.dataset.variantCompareLabel;
      }
      const sale = card.querySelector('[data-box-product-sale]');
      if (sale) sale.hidden = variantButton.dataset.variantOnSale !== 'true';
      const addButton = card.querySelector('[data-box-product-add]');
      if (addButton) addButton.setAttribute('aria-label', `Aggiungi ${variantButton.dataset.selectionTitle} alla box`);
      renderProductState();
    };

    const getCounts = () => {
      const counts = { standard: 0, bottle: 0, piennolo: 0, compact: 0, large: 0, total: 0, eligible: 0 };
      selection.forEach((item) => {
        counts[item.type] += item.quantity;
        if (item.type === 'standard') counts[item.size === 'compact' ? 'compact' : 'large'] += item.quantity;
        counts.total += item.quantity;
        counts.eligible += item.quantity;
      });
      return counts;
    };

    const getDiscountRate = (eligibleCount) => {
      if (eligibleCount >= 8 && discountCodes[10]) return 10;
      if (eligibleCount >= 5 && discountCodes[8]) return 8;
      if (eligibleCount >= 3 && discountCodes[5]) return 5;
      return 0;
    };

    const getValidity = (counts) => {
      if (!selectedFormat) return { valid: false, message: 'Scegli prima il formato della box.' };

      if (selectedFormat.key === 'small') {
        const compactOnly = counts.large === 0 && counts.compact === 5;
        const largeOrMixed = counts.large > 0 && counts.standard === 3;
        const valid = (compactOnly || largeOrMixed) && counts.bottle === 0 && counts.piennolo === 0;
        let status = counts.large > 0
          ? 'Completa la Box Piccola con 3 prodotti grandi o misti.'
          : 'Completa la Box Piccola con 5 prodotti nei formati 314 g, 390 ml o 212 ml.';
        if (valid) status = 'La Box Piccola è completa.';
        return {
          valid,
          message: status
        };
      }

      if (selectedFormat.key === 'medium') {
        const fiveProducts = counts.standard === 5 && counts.bottle === 0 && counts.piennolo === 0;
        const withBottle = counts.standard === 3 && counts.bottle === 1 && counts.piennolo === 0;
        return {
          valid: fiveProducts || withBottle,
          message: fiveProducts || withBottle ? 'La Box Media è completa.' : 'Completa con 5 prodotti oppure con 3 prodotti e 1 bottiglia.'
        };
      }

      const piennoloWithoutBottle = counts.piennolo === 1 && counts.standard === 5 && counts.bottle === 0;
      const piennoloWithBottle = counts.piennolo === 1 && counts.standard === 4 && counts.bottle === 1;
      const bottlesOnly = counts.piennolo === 0 && counts.standard === 0 && counts.bottle === 6;
      const mixed = counts.piennolo === 0 && counts.standard <= 10 && counts.bottle <= 2 && counts.total >= 8;
      const valid = piennoloWithoutBottle || piennoloWithBottle || bottlesOnly || mixed;
      let status = 'Componi almeno 8 referenze, fino a 10 prodotti e 2 bottiglie.';
      if (counts.piennolo) status = 'Con il Piennolo: aggiungi 5 prodotti, oppure 4 prodotti e 1 bottiglia.';
      if (counts.standard === 0 && counts.bottle > 0) status = 'La selezione solo Cantina richiede 6 bottiglie.';
      if (valid) status = 'Lo Scrigno Maxi è completo.';
      return { valid, message: status };
    };

    const canAdd = (type, size = 'large') => {
      if (!selectedFormat) return false;
      const counts = getCounts();

      if (selectedFormat.key === 'small') {
        if (type !== 'standard') return false;
        const addingLarge = size !== 'compact';
        const limit = counts.large > 0 || addingLarge ? 3 : 5;
        return counts.standard < limit;
      }

      if (selectedFormat.key === 'medium') {
        if (type === 'piennolo') return false;
        if (type === 'bottle') return counts.bottle < 1 && counts.standard <= 3;
        if (type === 'standard') return counts.standard < (counts.bottle ? 3 : 5);
        return false;
      }

      if (counts.piennolo) {
        if (type === 'piennolo') return false;
        if (type === 'bottle') return counts.bottle < 1 && counts.standard <= 4;
        if (type === 'standard') return counts.standard < (counts.bottle ? 4 : 5);
      }

      if (type === 'piennolo') return counts.piennolo === 0 && counts.bottle <= 1 && counts.standard <= (counts.bottle ? 4 : 5);
      if (type === 'bottle') return counts.standard === 0 ? counts.bottle < 6 : counts.bottle < 2;
      if (type === 'standard') return counts.bottle <= 2 && counts.standard < 10;
      return false;
    };

    const formatCapacityCopy = () => {
      const counts = getCounts();
      if (!selectedFormat) return 'Scegli un formato per iniziare.';
      if (selectedFormat.key === 'small') {
        if (counts.large > 0) return `${counts.standard} di 3 prodotti grandi o misti`;
        return `${counts.compact} di 5 prodotti · formati 314 g, 390 ml o 212 ml`;
      }
      if (selectedFormat.key === 'medium') return counts.bottle ? `${counts.standard} di 3 prodotti · ${counts.bottle} di 1 bottiglia` : `${counts.standard} di 5 prodotti · oppure aggiungi 1 bottiglia entro il terzo prodotto`;
      if (counts.piennolo) return `${counts.piennolo} Piennolo · ${counts.standard} prodotti · ${counts.bottle} bottiglie`;
      if (counts.standard === 0 && counts.bottle) return `${counts.bottle} di 6 bottiglie`;
      return `${counts.standard} di 10 prodotti · ${counts.bottle} di 2 bottiglie`;
    };

    const updateProgress = (validity) => {
      progress.forEach((step) => step.classList.remove('is-active'));
      if (!selectedFormat) progress.find((step) => step.dataset.boxProgress === 'format')?.classList.add('is-active');
      else if (!getCounts().total) progress.find((step) => step.dataset.boxProgress === 'products')?.classList.add('is-active');
      else if (validity.valid) progress.find((step) => step.dataset.boxProgress === 'summary')?.classList.add('is-active');
      else progress.find((step) => step.dataset.boxProgress === 'products')?.classList.add('is-active');
    };

    const renderProductState = () => {
      productCards.forEach((card) => {
        const selected = selection.has(card.dataset.variantId);
        const unavailable = card.dataset.unavailable === 'true';
        const allowed = canAdd(card.dataset.productType, card.dataset.productSize);
        card.classList.toggle('is-in-box', selected);
        card.classList.toggle('is-disabled', unavailable || !allowed);
        const button = card.querySelector('[data-box-product-add]');
        if (button) button.disabled = unavailable || !allowed;
      });
    };

    const renderSummary = () => {
      const counts = getCounts();
      const validity = getValidity(counts);
      const rate = getDiscountRate(counts.eligible);
      let subtotal = 0;
      let eligibleSubtotal = 0;

      selection.forEach((item) => {
        subtotal += item.price * item.quantity;
        eligibleSubtotal += item.price * item.quantity;
      });

      const discount = Math.round(eligibleSubtotal * rate / 100);
      const packagePrice = selectedFormat?.price || 0;
      const total = subtotal - discount + packagePrice;

      summaryTitle.textContent = selectedFormat?.label || 'Comincia dal formato.';
      summaryStatus.textContent = validity.message;
      capacityMessage.textContent = formatCapacityCopy();
      summaryEmpty.hidden = selection.size > 0;
      summaryItems.innerHTML = [...selection.values()].map((item) => `
        <article class="nv-box-summary-item">
          ${item.image ? `<img src="${escapeHtml(item.image)}" alt="">` : '<div class="nv-box-summary-item__placeholder">NV</div>'}
          <div><strong>${escapeHtml(item.title)}</strong><small>${escapeHtml(item.priceLabel)}${item.onSale ? ' · già in promozione' : ''}</small></div>
          <div class="nv-box-summary-item__quantity" aria-label="Quantità ${escapeHtml(item.title)}">
            <button type="button" data-box-decrease="${escapeHtml(item.id)}" aria-label="Riduci quantità">−</button>
            <span>${item.quantity}</span>
            <button type="button" data-box-increase="${escapeHtml(item.id)}" aria-label="Aumenta quantità">＋</button>
          </div>
        </article>
      `).join('');

      subtotalElement.textContent = money.format(subtotal / 100);
      packageElement.textContent = money.format(packagePrice / 100);
      discountLabel.textContent = rate ? `−${rate}%` : '';
      discountElement.textContent = `−${money.format(discount / 100)}`;
      savingRow.hidden = discount <= 0;
      totalElement.textContent = money.format(total / 100);
      submit.disabled = !validity.valid || !selectedFormat?.packageVariantId;
      errorElement.hidden = true;
      updateProgress(validity);
      renderProductState();
    };

    const addProduct = (card) => {
      const type = card.dataset.productType;
      const size = card.dataset.productSize || 'large';
      if (!canAdd(type, size)) {
        errorElement.textContent = 'Questo prodotto non entra nella composizione scelta. Rimuovi un articolo o scegli un formato diverso.';
        errorElement.hidden = false;
        return;
      }
      const id = card.dataset.variantId;
      const current = selection.get(id);
      if (current) current.quantity += 1;
      else selection.set(id, {
        id,
        type,
        size,
        title: card.dataset.title,
        price: Number(card.dataset.price),
        priceLabel: card.dataset.priceLabel,
        image: card.dataset.image,
        onSale: card.dataset.onSale === 'true',
        quantity: 1
      });
      renderSummary();
    };

    const changeQuantity = (id, direction) => {
      const item = selection.get(id);
      if (!item) return;
      if (direction > 0 && !canAdd(item.type, item.size)) {
        errorElement.textContent = 'Hai raggiunto la capienza prevista per questa composizione.';
        errorElement.hidden = false;
        return;
      }
      item.quantity += direction;
      if (item.quantity <= 0) selection.delete(id);
      renderSummary();
    };

    formatButtons.forEach((button) => button.addEventListener('click', () => {
      const changed = selectedFormat && selectedFormat.key !== button.dataset.boxFormat;
      selectedFormat = {
        key: button.dataset.boxFormat,
        label: button.dataset.label,
        packageVariantId: button.dataset.packageVariantId,
        price: Number(button.dataset.packagePrice || 0)
      };
      if (changed) selection.clear();
      formatButtons.forEach((formatButton) => {
        const selected = formatButton === button;
        formatButton.classList.toggle('is-selected', selected);
        formatButton.setAttribute('aria-pressed', String(selected));
      });
      composer.hidden = false;
      renderSummary();
      composer.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }));

    productCards.forEach((card) => card.querySelector('[data-box-product-add]')?.addEventListener('click', () => addProduct(card)));

    productCards.forEach((card) => {
      card.querySelectorAll('[data-box-variant]').forEach((variantButton) => {
        variantButton.addEventListener('click', () => setCardVariant(card, variantButton));
      });
    });

    filterButtons.forEach((button) => button.addEventListener('click', () => {
      activeFilter = button.dataset.boxFilter;
      activePage = 1;
      filterButtons.forEach((filterButton) => filterButton.classList.toggle('is-active', filterButton === button));
      applyProductFilters();
    }));

    searchInput?.addEventListener('input', () => {
      activeSearch = normalizeSearch(searchInput.value);
      activePage = 1;
      applyProductFilters();
    });

    searchClear?.addEventListener('click', () => {
      searchInput.value = '';
      activeSearch = '';
      activePage = 1;
      applyProductFilters();
      searchInput.focus();
    });

    pagination?.addEventListener('click', (event) => {
      const pageButton = event.target.closest('[data-box-page]');
      if (pageButton) activePage = Number(pageButton.dataset.boxPage);
      else if (event.target.closest('[data-box-page-prev]')) activePage -= 1;
      else if (event.target.closest('[data-box-page-next]')) activePage += 1;
      else return;
      applyProductFilters();
      builder.querySelector('[data-box-products]')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    summaryItems.addEventListener('click', (event) => {
      const decrease = event.target.closest('[data-box-decrease]');
      const increase = event.target.closest('[data-box-increase]');
      if (decrease) changeQuantity(decrease.dataset.boxDecrease, -1);
      if (increase) changeQuantity(increase.dataset.boxIncrease, 1);
    });

    message.addEventListener('input', () => {
      messageCount.textContent = String(message.value.length);
      updateProgress(getValidity(getCounts()));
    });

    submit.addEventListener('click', async () => {
      const validity = getValidity(getCounts());
      if (!validity.valid || !selectedFormat?.packageVariantId) {
        errorElement.textContent = selectedFormat?.packageVariantId ? validity.message : 'Collega nell’editor del tema il prodotto tecnico di questa confezione.';
        errorElement.hidden = false;
        return;
      }

      const counts = getCounts();
      const discountRate = getDiscountRate(counts.eligible);
      const discountCode = discountCodes[discountRate] || '';
      const boxId = `NV-${Date.now().toString(36).toUpperCase()}`;
      const baseProperties = {
        '_nv_box_id': boxId,
        '_nv_discount_tier': discountRate ? `${discountRate}%` : 'none',
        'Formato box': selectedFormat.label
      };
      const items = [...selection.values()].map((item) => ({
        id: Number(item.id),
        quantity: item.quantity,
        properties: {
          ...baseProperties,
          '_nv_box_role': 'product',
          '_nv_full_price': item.onSale ? 'false' : 'true'
        }
      }));
      const packagingProperties = {
        ...baseProperties,
        '_nv_box_role': 'packaging'
      };
      const giftMessage = message.value.trim();
      if (giftMessage) packagingProperties['Messaggio regalo'] = giftMessage;
      items.push({
        id: Number(selectedFormat.packageVariantId),
        quantity: 1,
        properties: packagingProperties
      });

      const originalLabel = submit.textContent;
      submit.disabled = true;
      submit.textContent = 'Preparo la tua box…';
      try {
        const response = await fetch(builder.dataset.cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!response.ok) throw new Error('cart');
        if (discountCode) {
          const rootUrl = builder.dataset.rootUrl || '/';
          const discountPath = `${rootUrl.replace(/\/$/, '')}/discount/${encodeURIComponent(discountCode)}`;
          window.location.assign(`${discountPath}?redirect=${encodeURIComponent(builder.dataset.cartUrl)}`);
        } else {
          window.location.assign(builder.dataset.cartUrl);
        }
      } catch (error) {
        errorElement.textContent = 'Non siamo riusciti ad aggiungere la box. Controlla la disponibilità dei prodotti e riprova.';
        errorElement.hidden = false;
        submit.disabled = false;
        submit.textContent = originalLabel;
      }
    });

    renderSummary();
    applyProductFilters();
  });
})();
